export class ExpiredStorage {
    constructor(storage = localStorage) {
        this.cleanupInterval = null;
        this.CLEANUP_INTERVAL = 60000; // 每分钟检查一次过期数据
        this.storage = storage;
        this.startCleanup();
    }
    /**
     * 设置带过期时间的数据
     * @param key 存储键
     * @param value 存储值
     * @param expireMinutes 过期时间（分钟）
     */
    setItem(key, value, expireMinutes = 120) {
        try {
            const now = Date.now();
            const expireTime = now + (expireMinutes * 60 * 1000);
            const item = {
                value,
                timestamp: now,
                expireTime
            };
            this.storage.setItem(key, JSON.stringify(item));
            console.log(`数据已存储，将在 ${expireMinutes} 分钟后过期:`, key);
            return true;
        }
        catch (e) {
            console.warn('存储失败:', e);
            return false;
        }
    }
    /**
     * 获取数据，如果过期则返回null
     * @param key 存储键
     */
    getItem(key) {
        try {
            const itemStr = this.storage.getItem(key);
            if (!itemStr)
                return null;
            const item = JSON.parse(itemStr);
            const now = Date.now();
            // 检查是否过期
            if (now > item.expireTime) {
                console.log('数据已过期，自动删除:', key);
                this.removeItem(key);
                return null;
            }
            return item.value;
        }
        catch (e) {
            console.warn('读取数据失败:', e);
            return null;
        }
    }
    /**
     * 删除数据
     * @param key 存储键
     */
    removeItem(key) {
        try {
            this.storage.removeItem(key);
            return true;
        }
        catch (e) {
            console.warn('删除数据失败:', e);
            return false;
        }
    }
    /**
     * 重置过期时间（延长30分钟）
     * @param key 存储键
     * @param expireMinutes 新的过期时间（分钟）
     */
    resetExpireTime(key, expireMinutes = 8888) {
        try {
            const itemStr = this.storage.getItem(key);
            if (!itemStr)
                return false;
            const item = JSON.parse(itemStr);
            const now = Date.now();
            const newExpireTime = now + (expireMinutes * 60 * 1000);
            // 更新过期时间
            item.expireTime = newExpireTime;
            item.timestamp = now;
            this.storage.setItem(key, JSON.stringify(item));
            console.log(`已重置过期时间，将在 ${expireMinutes} 分钟后过期:`, key);
            return true;
        }
        catch (e) {
            console.warn('重置过期时间失败:', e);
            return false;
        }
    }
    /**
     * 检查数据是否存在且未过期
     * @param key 存储键
     */
    hasItem(key) {
        return this.getItem(key) !== null;
    }
    /**
     * 获取剩余过期时间（分钟）
     * @param key 存储键
     */
    getRemainingTime(key) {
        try {
            const itemStr = this.storage.getItem(key);
            if (!itemStr)
                return 0;
            const item = JSON.parse(itemStr);
            const now = Date.now();
            const remaining = item.expireTime - now;
            return Math.max(0, Math.ceil(remaining / (60 * 1000))); // 返回剩余分钟数
        }
        catch (e) {
            return 0;
        }
    }
    /**
     * 启动自动清理任务
     */
    startCleanup() {
        if (this.cleanupInterval)
            return;
        this.cleanupInterval = window.setInterval(() => {
            this.cleanupExpiredItems();
        }, this.CLEANUP_INTERVAL);
    }
    /**
     * 清理过期数据
     */
    cleanupExpiredItems() {
        try {
            const now = Date.now();
            const keysToRemove = [];
            // 遍历所有存储项，找出过期的
            for (let i = 0; i < this.storage.length; i++) {
                const key = this.storage.key(i);
                if (!key)
                    continue;
                try {
                    const itemStr = this.storage.getItem(key);
                    if (!itemStr)
                        continue;
                    const item = JSON.parse(itemStr);
                    // 检查是否是我们的过期存储格式
                    if (item.expireTime && now > item.expireTime) {
                        keysToRemove.push(key);
                    }
                }
                catch (e) {
                    // 忽略非JSON格式的数据
                    continue;
                }
            }
            // 删除过期的数据
            keysToRemove.forEach(key => {
                this.storage.removeItem(key);
                console.log('自动清理过期数据:', key);
            });
            if (keysToRemove.length > 0) {
                console.log(`清理了 ${keysToRemove.length} 个过期数据项`);
            }
        }
        catch (e) {
            console.warn('清理过期数据时出错:', e);
        }
    }
    /**
     * 停止自动清理任务
     */
    destroy() {
        if (this.cleanupInterval) {
            clearInterval(this.cleanupInterval);
            this.cleanupInterval = null;
        }
    }
}
// 创建全局实例
export const expiredStorage = new ExpiredStorage();
